// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_KEY: 'AIzaSyDEi1C9UrghSIiCbhh5ldfbr0XyelRQsO0',
  // Lead Dashboard icon for every gym (off in the production build until go-live, see environment.prod.ts)
  showLeadDashboard: true,
  // VZBAL app the Meta button opens (fitness-node docs/plan-vzbal-official-whatsapp.md Q6)
  metaAppUrl: 'https://www.media.vzbal.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
